module.exports = __webpack_require__.p + "e74f95aaff3490cff24a2194a10d10f5.jpg";